import { inject, Injectable } from '@angular/core';
import { LogService } from '@common-modules/shared/wlm-log/log.service';

@Injectable({ providedIn: 'root' })
export class MapLogService {
  private readonly _enableLog = false;
  private readonly _logService = inject(LogService);

  log = (msg: string, payload?): void => {
    if (this._enableLog) {
      this._logService.info({
        msg,
        payload,
      });
    }
  };
}
